// extracted by mini-css-extract-plugin
export default {"total-price-section":"CouponTemplate_total-price-section__ZZTXl"};